@use "../../scss/colors";
@use "../../scss/breakpoints";

.valueProp {
	background-color: colors.$white;
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 84px 0 48px;
	@include breakpoints.sm-down {
		padding: 48px 0 48px;
	}
}

.textWrapper {
	width: 100%;
	max-width: 1440px;
	margin: 0 auto;
	padding: 0 96px;
	box-sizing: border-box;
	@include breakpoints.sm-down {
		padding: 0 32px;
	}
}

.text {
	max-width: 976px;
	margin: 0;
	font-family: "GT Eesti Display", sans-serif;
	font-weight: 400;
	font-size: 32px;
	line-height: 42px;
	color: #182428;
	@include breakpoints.sm-down {
		font-size: 24px;
		line-height: 32px;
	}
}
